import { connect } from 'react-redux';
import { compose} from 'recompose';

import UserInfo from './UserInfo';

const mapStateToProps = state => ({
    data: state,
});

export default compose(
    connect(mapStateToProps),
)(UserInfo);
